// Logo Marquee Swiper - Infinite Scroll
$(".logo-marquee-section .swiper.marquee-swiper").each(function() {
  new Swiper(this, {
    slidesPerView: "4", // Slides take up the width defined in our CSS
    spaceBetween: 80, // Adds breathing room between logos (adjusted for logos)
    loop: true, // If it doesn't loop, what are we even doing here?
    speed: 1000, // Time in ms for one slide to transition. Change this to your liking.
    allowTouchMove: false, // It's a marquee, not an interactive carnival ride
    autoplay: {
      delay: 1, // 1 millisecond delay: we're moving nonstop. Try 0 here too :).
      disableOnInteraction: false, // If someone tries to touch, let them fail in peace
    },
    breakpoints: {
      768: {
        slidesPerView: "5",
      },
      992: {
        slidesPerView: "6",
      },
    },
    1440: {
      slidesPerView: "8",
    },
  });
});
